import { createContext } from 'react';

export { default as DepartmentsProvider } from './DepartmentsProvider';
export { default as WorkingPlacesProvider } from './WorkingPlacesProvider';

export const DepartmentContext = createContext({});
export const WorkingPlaceContext = createContext({});
